import { AuthRefreshResponse } from "@shared/models/auth";
import { GetUserApi } from "@shared/models/user";
import { requestInstance } from "@shared/request-instance";

export const getUserApi: GetUserApi = async () => {
  const response = await requestInstance.get<AuthRefreshResponse>("/user");

  return response.data;
};
